import React from 'react'
import ActivityStream from '../../../enquiry/activity_stream/ActivityStream'
import Tasks from '../../../tasks/index'

class LeadActivity extends React.Component {

  render() {
    const lead = this.props.lead

    return (
      <div className="flex flex-col gap-4">
        <Tasks
          key={`Sales::Lead::${lead.id}::${lead.updated_at}`}
          taskable_type='Sales::Lead'
          taskable_id={lead.id}
        />
        <ActivityStream
          comments={lead.comments}
          commentable_type='Sales::Lead'
          commentable_id={lead.id}
        />
      </div>
    )
  }
}

export default LeadActivity
